import { render, staticRenderFns } from "./AiHome.vue?vue&type=template&id=772298dd&scoped=true&"
import script from "./AiHome.vue?vue&type=script&lang=js&"
export * from "./AiHome.vue?vue&type=script&lang=js&"
import style0 from "./AiHome.vue?vue&type=style&index=0&id=772298dd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "772298dd",
  null
  
)

export default component.exports